// 平安定制
import publicRequest from '@/plugin/axios/request-public.js';

// 任务详情
export const getTaskDetail = (data) => publicRequest({
  url: '/vas/app/query/taskDetail',
  method: 'post',
  data
});

// 获取影像模板
export const getMediaTemplate = (data) => publicRequest({
  url: '/vas/common/mediaTemplate',
  method: 'post',
  data
});

// 获取优惠信息
export const getRightRemark = (data) => publicRequest({
  url: '/vas/app/query/getRightRemark',
  method: 'post',
  data
});

// 当前订单可使用的增值产品
export const getExtraProductList = (data) => publicRequest({
  url: '/vas/app/query/extraProduct/list',
  method: 'post',
  data
});

// 开始作业（当前任务状态为已到达）
export const beginWork = (data) => publicRequest({
  url: '/vas/app/operate/beginWork',
  method: 'post',
  data
});

// 完成作业（当前任务状态为服务完成）
export const finishWork = (data) => publicRequest({
  url: '/vas/app/operate/finish',
  method: 'post',
  data
});

// 放空&救援失败调用接口
export const rescueResult = (data) => publicRequest({
  url: '/vas/app/operate/rescueResult',
  method: 'post',
  data
});

// 非拖车订单执行完成
export const executeSuccess = (data) => publicRequest({
  url: '/vas/app/operate/executeSuccess',
  method: 'post',
  data
});

// 保存信息（当前任务状态为已到达）
export const saveInfo = (data) => publicRequest({
  url: '/vas/app/operate/appSaveRescueExtraInfo',
  method: 'post',
  data
});

// 保存任务模板类型
export const savePictureTemplate = (data) => publicRequest({
  url: '/vas/app/operate/savePictureTemplate',
  method: 'post',
  data
});

// 查询费用信息（当前任务状态为已到达）
export const queryOrderFeeDetail = (data) => publicRequest({
  url: '/vas/app/operate/queryOrderFeeDetail',
  method: 'post',
  data
});

// 保存费用信息（当前任务状态为已到达）
export const saveOrderFeeDetail = (data) => publicRequest({
  url: '/vas/app/operate/saveOrderFeeDetail',
  method: 'post',
  data
});

// 检查照片数量
export const checkPictureNum = (data) => publicRequest({
  url: '/vas/app/operate/checkPictureNum',
  method: 'post',
  data
});

// 查询服务事故拖车增值字典
export const queryAccidentVasDict = (data) => publicRequest({
    url: '/vas/app/query/queryAccidentVasDict',
    method: 'post',
    data
  });
//   App作业人员上传增值产品
export const saveExtra = (data) => publicRequest({
    url: '/vas/app/operate/saveExtra',
    method: 'post',
    data
  });

//   保存任务工单
export const saveRescueReport = (data) => publicRequest({
  url: '/vas/app/operate/saveRescueReport',
  method: 'post',
  data
});

//   查询任务工单
export const getRescueReport = (data) => publicRequest({
  url: '/vas/app/query/getRescueReport',
  method: 'post',
  data
});
//   申诉里程
export const appealDistance = (data) => publicRequest({
  url: '/vas/app/operate/appealDistance',
  method: 'post',
  data
});
//   修改任务订单tag
export const updateOrderTag = (data) => publicRequest({
  url: '/vas/app/operate/updateOrderTag',
  method: 'post',
  data
});
